import { Injectable, TemplateRef, inject } from '@angular/core';
import { Validators } from '@angular/forms';

import { Observable, filter, map } from 'rxjs';

import { WysiswgBlockData } from '@camelot/wysiswyg';

import { CamAbstractInput, InputEmail, InputPanel, InputTextBox, InputWysiswyg } from '@camelot/form-model';
import { CamContactService } from '@camelot/services';
import { isNonNullable } from '@camelot/utils';

export interface EmailSendFormOptions {
  contactId: string;
  subject: string;
  ccVisible$: Observable<boolean>;
  recipientLabelTemplate: TemplateRef<void>;
  bodyLabelTemplate: TemplateRef<void>;
  setBody$: Observable<WysiswgBlockData[]>;
}

@Injectable({
  providedIn: 'root',
})
export class CamEmailSendFormService {
  private readonly _contactService = inject(CamContactService);

  public getEmailForm(options: EmailSendFormOptions): CamAbstractInput[] {
    return [
      new InputPanel({
        key: 'emailFormPanel',
        contentClass: 'flex-column g-space-sm',
        children: [
          new InputEmail({
            class: 'col-12',
            key: 'to',
            label: 'communication.email.to',
            labelTemplate: options.recipientLabelTemplate,
            value$: this._contactService.fetchContactById$(options.contactId).pipe(
              filter(isNonNullable),
              map(contact => contact.mail ?? '')
            ),
            validators: [Validators.required, Validators.email],
          }),
          new InputEmail({
            class: 'col-12',
            key: 'cc',
            label: 'communication.email.cc',
            validators: [Validators.email],
            visible$: options.ccVisible$,
          }),
          new InputTextBox({
            class: 'col-12',
            key: 'subject',
            label: 'communication.email.subject',
            value: options.subject,
            validators: [Validators.required],
          }),
          new InputWysiswyg({
            class: 'col-12',
            key: 'body',
            label: 'communication.email.message.text',
            labelTemplate: options.bodyLabelTemplate,
            value$: options.setBody$,
          }),
        ],
      }),
    ];
  }
}
